(function() {
    "use strict";

    const $ = require('jquery');
    const ko = require('knockout');
    const koQuill = require('../components/ko.quill');

    class RoleplayViewModel {
        constructor(data) {
            this.chapters = ko.observableArray([]);
            this.id = data.id;
            this.title = ko.observable(data.title || '');
            this.description = ko.observable(data.description || '{}');
            this.author = ko.observable(data.author || '');
        }

        load() {
            if (this.id) {
                $.ajax('/api/search/chapters?roleplay=' + this.id, {
                    method: 'get',
                    success: data => {
                        this.chapters(data);
                    }
                });
            }
        }
    }

    module.exports = RoleplayViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/roleplayViewModel.js